import { z } from 'zod';

export const formSchema = z.object({
  serviceOrderId: z.number(),
  cancellationReason: z.string({ required_error: 'Informe uma justificativa' })
    .min(1, 'Informe uma justificativa')
    .max(200, 'Limite a justificativa a 20 caracteres'),
});

export type FormSchema = z.infer<typeof formSchema>